import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { AccordionItem } from './components/accordionItem';
import { useAccordion } from './useAccordion';

const AccordionContainer = styled.div`
  width: 100%;
  border-top: solid 1px ${({ theme }) => theme?.colors?.border?.subtle};
`;

export const Accordion = ({ items, defaultOpenIds, onChange, allowMultiple }) => {
  const { openIds, handleToggle } = useAccordion({ defaultOpenIds, allowMultiple, onChange });

  return (
    <AccordionContainer>
      {items.map((item) => (
        <AccordionItem
          key={item.id}
          id={item.id}
          title={item.title}
          badge={item.badge || ''}
          isOpen={openIds.has(item.id)}
          onToggle={handleToggle}
        >
          {item.content}
        </AccordionItem>
      ))}
    </AccordionContainer>
  );
};

Accordion.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.node.isRequired,
      content: PropTypes.node,
      badge: PropTypes.node,
    }),
  ).isRequired,
  defaultOpenIds: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  allowMultiple: PropTypes.bool,
};

Accordion.defaultProps = {
  defaultOpenIds: [],
  onChange: undefined,
  allowMultiple: true,
};

export default Accordion;
